import React, { Component } from "react";
import "./Report.css";
import { Link } from "react-router-dom";
import { Breadcrumb, PageHeader, Glyphicon } from "react-bootstrap";
import FleetDatePicker from '../../components/FleetDatePicker';

export default class Report extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };
  }

  handleDatesSelec = (dates) => {
    alert(dates.startDate);
  }

  render() {
    return (
      <div className="Report">
	    <Breadcrumb>
	      <Breadcrumb.Item componentClass={Link} href="/" to="/">Home</Breadcrumb.Item>
	      <Breadcrumb.Item active>Reportes</Breadcrumb.Item>
	      <Glyphicon className="help" glyph="info-sign" onClick={this.handleHelp} />
		</Breadcrumb>
      	<PageHeader>
	      Reportes
	    </PageHeader>
	    <FleetDatePicker onSelect={this.handleDatesSelec}/>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/report/Report.js